import React, { useEffect } from 'react';
import { Container, Typography, CircularProgress, Card, CardContent, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Success() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to premium content after 3 seconds
    const timer = setTimeout(() => {
      navigate('/courses');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 6, md: 9 }, minHeight: 'calc(100vh - 120px)' }}>
      <Card
        sx={{
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 5,
          boxShadow: (theme) =>
            theme.palette.mode === 'dark'
              ? '0 24px 80px rgba(0, 0, 0, 0.24)'
              : '0 24px 80px rgba(82, 107, 170, 0.12)',
        }}
      >
        <CardContent
          sx={{
            p: { xs: 4, md: 5 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Chip label="Payment complete" size="small" sx={{ mb: 2, bgcolor: 'action.hover', color: 'text.secondary', fontWeight: 700 }} />
          <Typography variant="h4" sx={{ fontWeight: 850, color: 'text.primary', mb: 1 }}>
            Premium is unlocked.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
            You now have access to every course, roadmap, quiz, and flashcard.
          </Typography>
          <CircularProgress sx={{ color: 'secondary.main' }} />
          <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
            Redirecting to courses...
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
} 
